import React from "react"

export default function StepTabs({ tabContent, currentTab, mainClass }) {
  return (
    <div className={ mainClass }>
      { 
        tabContent.map((tab, idx) =>( 
          <div key={idx} className={`${tab.className} ${idx <= currentTab ? "active" : ""}`}>
            {`${tab.name}`}
          </div> 
        ))
      }
    </div>
  )
}